import { MessageCircle } from 'lucide-react';

const SHARE_MESSAGES = {
  manual: {
    path: '/manual27',
    text: 'Hola! Te comparto la oferta del Manual Completo Travel Empire — 156 paginas + viaje a Orlando para 4 personas, todo por solo $27 USD:',
  },
  libro: {
    path: '/libro',
    text: 'Hola! Te comparto el libro "Emprendedor o Empleado?" de Carlos Miami Fernandez. Es la lectura que cambio mi forma de pensar sobre el dinero y el tiempo:',
  },
  fdacs: {
    path: '/licencias/fdacs',
    text: 'Hola! Aqui tienes la Licencia FDACS (Florida Seller of Travel Registration ST39568) de Club Viajemos:',
  },
  bond: {
    path: '/licencias/bond',
    text: 'Hola! Aqui tienes el Surety Bond ($25,000 USD) de TONS OF LEADS LLC / Club Viajemos:',
  },
  'florida-certificate': {
    path: '/licencias/florida-certificate',
    text: 'Hola! Aqui tienes el Florida Seller of Travel — Registration Certificate (vigente 2026) de Club Viajemos / TONS OF LEADS LLC dba VIAJEMOS:',
  },
  comoganardinero: {
    path: '/comoganardinero',
    text: 'Hola! Te comparto el Sistema Completo de Alianzas Universitarias LATAM de Club Viajemos / Travel Empire — la guia paso a paso para empezar a generar ingresos como agente de viajes:',
  },
  vendeconia: {
    path: '/vendeconia',
    text: 'Hola! Te comparto un sistema de ventas con Inteligencia Artificial de Club Viajemos — un AI Funnel + Asistente IA que vende 24/7 por ti:',
  },
  prospecciondigital: {
    path: '/prospecciondigital',
    text: 'Hola! Te comparto el Programa PhD de Prospeccion Digital de Club Viajemos — la formacion mas completa para convertir tu prospeccion en un sistema profesional:',
  },
};

export const ShareWhatsAppButton = ({ docKey, className = '' }) => {
  const info = SHARE_MESSAGES[docKey];
  if (!info) return null;

  const url = typeof window !== 'undefined' ? `${window.location.origin}${info.path}` : info.path;
  const message = encodeURIComponent(`${info.text}\n\n${url}`);
  const waUrl = `https://wa.me/?text=${message}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`share-whatsapp-${docKey}`}
      title="Compartir por WhatsApp"
      className={`flex items-center gap-2 bg-[#25D366] hover:bg-[#1faa54] text-white font-medium px-3 py-2 rounded-lg transition-colors text-sm flex-shrink-0 ${className}`}
    >
      <MessageCircle className="h-4 w-4" />
      <span className="hidden sm:inline">Compartir</span>
    </a>
  );
};

export default ShareWhatsAppButton;
